import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Table,
	Typography
} from "antd";

import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
	addEmploymentStatus,
	loadAllEmploymentStatus,
} from "../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import ViewBtn from "../Buttons/ViewBtn";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

import { HexColorPicker } from "react-colorful";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

function CustomTable({ list, loading }) {
	const [columnsToShow, setColumnsToShow] = useState([]);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			id: 2,
			title: "Name",
			dataIndex: "name",
			key: "name",
		},

		{
			id: 3,
			title: "Color Code",
			dataIndex: "colourValue",
			key: "colourValue",
			render: (colourValue) => (
				<div className='flex'>
					<div
						className='rounded border border-gray-200'
						style={{
							marginRight: "10px",
							width: "20px",
							height: "20px",
							backgroundColor: colourValue,
						}}></div>
					{colourValue}
				</div>
			),
		},

		{
			id: 4,
			title: "Description",
			dataIndex: "description",
			key: "description",
		},
		{
			id: 5,
			title: "Action",
			dataIndex: "id",
			key: "action",
			render: (id) => <ViewBtn path={`/admin/employment-status/${id}/`} />,
		},
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	return (
		<Card>
			<div className='text-center my-2 flex justify-between'>
				<h5 className='department-list-title text-color-2 text-xl mb-2'>
					Employment Status List
				</h5>
				{list && (
					<div>
						<CsvLinkBtn>
							<CSVLink
								data={list}
								className='btn btn-dark btn-sm mb-1'
								filename='employment_list'>
								Download CSV
							</CSVLink>
						</CsvLinkBtn>
					</div>
				)}
			</div>

			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}

			<Table
				scroll={{ x: true }}
				loading={loading}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
		</Card>
	);
}

const AddEmploymentStatus = ({ drawer }) => {
	const [loader, setLoader] = useState(false);
	const { list, loading } = useSelector((state) => state.employmentStatus);
	const [color, setColor] = useState("#ffffff");
	const [showColorPicker, setShowColorPicker] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(loadAllEmploymentStatus());
	}, []);

	const { Title } = Typography;
	const [form] = Form.useForm();

	const onFinish = async (values) => {
		const FormData = {
			...values,
			colourValue: color,
		};

		setLoader(true);
		const resp = await dispatch(addEmploymentStatus(FormData));

		if (resp.payload.message === "success") {
			setLoader(false);
			form.resetFields();
			dispatch(loadAllEmploymentStatus());
		} else {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at adding status");
		setLoader(false);
	};
	return (
		<div className="container mx-auto">
		  <Row className="mr-top" gutter={[16, 16]}>
			<Col xs={24} sm={24} md={10} lg={10} xl={10}>
			  <Card bordered={true} className="h-full">
				<UserPrivateComponent permission={"create-employmentStatus"}>
				  <div className="text-center mb-4">
					<Typography.Title level={4}>
					  Add Employment Status
					</Typography.Title>
				  </div>
				  <Form
					form={form}
					name="employmentStatusForm"
					layout="vertical"
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete="off"
				  >
					<Form.Item
					  label={<span className="required-label">Name:</span>}
					  name="name"
					  rules={[
						{
						  required: true,
						  message: "Please input status name!",
						},
					  ]}
					>
					  <Input placeholder="Permanent" />
					</Form.Item>
	
					<Form.Item
					  label="Color Code:"
					  name="colourValue"
					>
					  <Input
						placeholder="#00FF00"
						value={color}
						onChange={(e) => setColor(e.target.value)}
						onClick={() => setShowColorPicker(true)}
					  />
					  {showColorPicker && (
						<div className="mt-3 mb-3">
						  <div className="flex justify-between mb-2">
							<HexColorPicker
							  onChange={(i) => setColor(i)}
							  color={color}
							/>
						  </div>
						  <Button
							danger
							onClick={() => setShowColorPicker(false)}
						  >
							Close
						  </Button>
						</div>
					  )}
					</Form.Item>
	
					<Form.Item
					  label="Description:"
					  name="description"
					>
					  <Input.TextArea placeholder="Description" />
					</Form.Item>
	
					<Form.Item>
					  <Button
						type="primary"
						size="large"
						htmlType="submit"
						block
						loading={loader}
					  >
						Add Employment Status
					  </Button>
					</Form.Item>
				  </Form>
				</UserPrivateComponent>
			  </Card>
			</Col>
			
			<Col xs={24} sm={24} md={14} lg={14} xl={14}>
			  <UserPrivateComponent permission={"readAll-employmentStatus"}>
				<CustomTable list={list} loading={loading} />
			  </UserPrivateComponent>
			</Col>
		  </Row>
		</div>
	  );
};

export default AddEmploymentStatus;
